<script>
import { Row, Col, Tabs, Tab } from 'vant'
import TextSwitcher from '@/components/org/TextSwitcher'
import CheckboxCard from '@/components/org/CheckboxCard'
import ToggleButtonGroup from '@/components/org/ToggleButtonGroup'
import MatchSignupMemberConfig from '@/tbs/model/vo/MatchSignupMemberConfig'

const matchSignupMemberConfig = new MatchSignupMemberConfig

export default {
    //--------------------------------------------------
	// component name
	//--------------------------------------------------
	name: 'org-match-signup-member-config-edit',

    //--------------------------------------------------
	// component components
	//--------------------------------------------------
    components: {
        'van-row': Row,
        'van-col': Col,
        'van-tabs': Tabs,
        'van-tab': Tab,
        'text-switcher': TextSwitcher,
        'checkbox-card': CheckboxCard,
        'toggle-button-group': ToggleButtonGroup,
    },

    //--------------------------------------------------
    // component emits
    //--------------------------------------------------
	emits: ['custom-event'],

    //--------------------------------------------------
    // component data
    //--------------------------------------------------
    data() {
        return {
            matchGroup: {
                id: null,
                isMemberNameChecked: null,
                isMemberNumChecked: null,
                isMemberContactPhoneChecked: null,
                isMemberGenderChecked: null,
                isMemberBirthChecked: null,
                isMemberCredentialsChecked: null,
                memberCredentialsItems: null,
                isMemberHeightChecked: null,
                isMemberWeightChecked: null,
                isMemberSuitSizeChecked: null,
                isMemberShoeSizeChecked: null,
                isMemberParentNameChecked: null,
                isMemberParentContactPhoneChecked: null,
                isMemberSchoolChecked: null,
                isMemberInsuranceChecked: null,
                isMemberPositionChecked: null,
                isMemberQualificationChecked: null,
                isMemberSuitNameChecked: null,
                isMemberDutyChecked: null,
                isMemberCityChecked: null,
                isMemberNationChecked: null,
                isMemberCountryChecked: null,
                isMemberWorkUnitChecked: null,
                isMemberProfessionChecked: null,
                isMemberTeamChecked: null,
                isMemberRegistrationCodeChecked: null,
                isMemberProfessionalPlayerChecked: null,
                isMemberEmergencyContactChecked: null,
                isMemberRemarkChecked: null,
                isMemberGenderReadonly: null,
                isMemberBirthReadonly: null,
            },
            locale: {}
        }
    },

    //--------------------------------------------------
    // computed setter and getter
    //--------------------------------------------------
    computed: {
    },

    //--------------------------------------------------
    // component methods
    //--------------------------------------------------
    methods: {
        onSaveBtnClick() {
            this.$emit('custom-event', {
                type: 'save',
                data: this.matchGroup
            })
        },
        onMemberNameDataChange(data) {
            if (data == this.matchGroup.isMemberNumChecked) {
                return
            }
            this.matchGroup.isMemberNumChecked = data
            this.submitData()
        },
        onMemberContactPhoneDataChange(data) {
            if (data == this.matchGroup.isMemberContactPhoneChecked) {
                return
            }
            this.matchGroup.isMemberContactPhoneChecked = data
            this.submitData()
        },
        onMemberGenderDataChange(data) {
            if (data == this.matchGroup.isMemberGenderChecked) {
                return
            }
            this.matchGroup.isMemberGenderChecked = data
            this.submitData()
        },
        onMemberBirthDataChange(data) {
            if (data == this.matchGroup.isMemberBirthChecked) {
                return
            }
            this.matchGroup.isMemberBirthChecked = data
            this.submitData()
        },
        onMemberCredentialsDataChange(data) {
            if (data == this.matchGroup.isMemberCredentialsChecked) {
                return
            }
            this.matchGroup.isMemberCredentialsChecked = data
            if (this.matchGroup.isMemberCredentialsChecked == false) {
                // clear the items while member credentials not checked
                this.matchGroup.memberCredentialsItems = []
            }
            else {
                // set the preset values for the items while member credentials checked
                this.matchGroup.memberCredentialsItems = matchSignupMemberConfig.getDefaultMemberCredentialsItems()
            }
            this.submitData()
        },
        onMemberCredentialsItemDataChange(data) {
            console.log('onMemberCredentialsItemDataChange', data)
            this.matchGroup.memberCredentialsItems = data
            this.submitData()
        },
        onMemberHeightDataChange(data) {
            if (data == this.matchGroup.isMemberHeightChecked) {
                return
            }
            this.matchGroup.isMemberHeightChecked = data
            this.submitData()
        },
        onMemberWeightDataChange(data) {
            if (data == this.matchGroup.isMemberWeightChecked) {
                return
            }
            this.matchGroup.isMemberWeightChecked = data
            this.submitData()
        },
        onMemberSuitSizeDataChange(data) {
            if (data == this.matchGroup.isMemberSuitSizeChecked) {
                return
            }
            this.matchGroup.isMemberSuitSizeChecked = data
            this.submitData()
        },
        onMemberShoeSizeDataChange(data) {
            if (data == this.matchGroup.isMemberShoeSizeChecked) {
                return
            }
            this.matchGroup.isMemberShoeSizeChecked = data
            this.submitData()
        },
        onMemberSuitNameDataChange(data) {
            if (data == this.matchGroup.isMemberSuitNameChecked) {
                return
            }
            this.matchGroup.isMemberSuitNameChecked = data
            this.submitData()
        },
        onMemberParentNameDataChange(data) {
            if (data == this.matchGroup.isMemberParentNameChecked) {
                return
            }
            this.matchGroup.isMemberParentNameChecked = data
            this.submitData()
        },
        onMemberParentContactPhoneDataChange(data) {
            if (data == this.matchGroup.isMemberParentContactPhoneChecked) {
                return
            }
            this.matchGroup.isMemberParentContactPhoneChecked = data
            this.submitData()
        },
        onMemberSchoolDataChange(data) {
            if (data == this.matchGroup.isMemberSchoolChecked) {
                return
            }
            this.matchGroup.isMemberSchoolChecked = data
            this.submitData()
        },
        onMemberInsuranceDataChange(data) {
            if (data == this.matchGroup.isMemberInsuranceChecked) {
                return
            }
            this.matchGroup.isMemberInsuranceChecked = data
            this.submitData()
        },
        onMemberPositionDataChange(data) {
            if (data == this.matchGroup.isMemberPositionChecked) {
                return
            }
            this.matchGroup.isMemberPositionChecked = data
            this.submitData()
        },
        onMemberQualificationDataChange(data) {
            if (data == this.matchGroup.isMemberQualificationChecked) {
                return
            }
            this.matchGroup.isMemberQualificationChecked = data
            this.submitData()
        },
        onMemberDutyDataChange(data) {
            if (data == this.matchGroup.isMemberDutyChecked) {
                return
            }
            this.matchGroup.isMemberDutyChecked = data
            this.submitData()
        },
        onMemberCityDataChange(data) {
            if (data == this.matchGroup.isMemberCityChecked) {
                return
            }
            this.matchGroup.isMemberCityChecked = data
            this.submitData()
        },
        onMemberNationDataChange(data) {
            if (data == this.matchGroup.isMemberNationChecked) {
                return
            }
            this.matchGroup.isMemberNationChecked = data
            this.submitData()
        },
        onMemberCountryDataChange(data) {
            if (data == this.matchGroup.isMemberCountryChecked) {
                return
            }
            this.matchGroup.isMemberCountryChecked = data
            this.submitData()
        },
        onMemberWorkUnitDataChange(data) {
            if (data == this.matchGroup.isMemberWorkUnitChecked) {
                return
            }
            this.matchGroup.isMemberWorkUnitChecked = data
            this.submitData()
        },
        onMemberProfessionDataChange(data) {
            if (data == this.matchGroup.isMemberProfessionChecked) {
                return
            }
            this.matchGroup.isMemberProfessionChecked = data
            this.submitData()
        },
        onMemberTeamDataChange(data) {
            if (data == this.matchGroup.isMemberTeamChecked) {
                return
            }
            this.matchGroup.isMemberTeamChecked = data
            this.submitData()
        },
        onMemberRegistrationCodeDataChange(data) {
            if (data == this.matchGroup.isMemberRegistrationCodeChecked) {
                return
            }
            this.matchGroup.isMemberRegistrationCodeChecked = data
            this.submitData()
        },
        onMemberProfessionalPlayerDataChange(data) {
            if (data == this.matchGroup.isMemberProfessionalPlayerChecked) {
                return
            }
            this.matchGroup.isMemberProfessionalPlayerChecked = data
            this.submitData()
        },
        onMemberEmergencyContactDataChange(data) {
            if (data == this.matchGroup.isMemberEmergencyContactChecked) {
                return
            }
            this.matchGroup.isMemberEmergencyContactChecked = data
            this.submitData()
        },
        onMemberRemarkDataChange(data) {
            if (data == this.matchGroup.isMemberRemarkChecked) {
                return
            }
            this.matchGroup.isMemberRemarkChecked = data
            this.submitData()
        },
        submitData() {
            console.log('submit data', this.matchGroup)
            this.$emit('custom-event', {
                type: 'submit',
                data: this.matchGroup
            })
        },
    },
}
</script>

<template>
    <div class="match-signup-member-config-edit">
        <div class="nav-op-bar fixed-top">
            <van-row class="hp100 vertical-center">
                <van-col 
                    class="main-text primary-color text-right u-inner-padding" 
                    span="24"
                    @click="onSaveBtnClick">
                    {{ locale['confirm'] }}
                </van-col>
            </van-row>
        </div>
        <div class="main-fields">
            <text-switcher 
                :label="locale['signup-member-config-type-1']"
                :checked="matchGroup.isMemberNameChecked"
                :readonly="true"
            />
            <text-switcher 
                :label="locale['signup-member-config-type-2']"
                :checked="matchGroup.isMemberNumChecked"
                @change-data="onMemberNameDataChange"
            />
            <text-switcher 
                :label="locale['signup-member-config-type-3']"
                :checked="matchGroup.isMemberContactPhoneChecked"
                @change-data="onMemberContactPhoneDataChange"
            />
            <text-switcher 
                :label="locale['signup-member-config-type-4']"
                :checked="matchGroup.isMemberGenderChecked || matchGroup.isMemberGenderReadonly"
                :readonly="matchGroup.isMemberGenderReadonly"
                @change-data="onMemberGenderDataChange"
            />
            <text-switcher 
                :label="locale['signup-member-config-type-5']"
                :checked="matchGroup.isMemberBirthChecked || matchGroup.isMemberBirthReadonly"
                :readonly="matchGroup.isMemberBirthReadonly"
                @change-data="onMemberBirthDataChange"
            />
            <text-switcher 
                :label="locale['signup-member-config-type-6']"
                :checked="matchGroup.isMemberCredentialsChecked"
                :separated="false"
                @change-data="onMemberCredentialsDataChange"
            />
            <toggle-button-group
                v-if="matchGroup.isMemberCredentialsChecked"
                :items="matchGroup.memberCredentialsItems"
                @change-data="onMemberCredentialsItemDataChange"
            />
        </div>
        <div class="u-outer-padding no-padding-bottom">
            <span class="minor-text minor-color">{{ locale['other-data-item'] }}</span>
        </div>
        <div class="minor-fields">
            <van-tabs>
                <van-tab class="t-outer-margin" :title="locale['other-data-tab-type-1']">
                    <van-row class="u-inner-padding" gutter="10">
                        <van-col class="b-outer-margin" span="12">
                            <checkbox-card
                                :label="locale['signup-member-config-type-7']"
                                :checked="matchGroup.isMemberHeightChecked"
                                @change-data="onMemberHeightDataChange"
                            />
                        </van-col>
                        <van-col class="b-outer-margin" span="12">
                            <checkbox-card
                                :label="locale['signup-member-config-type-8']"
                                :checked="matchGroup.isMemberWeightChecked"
                                @change-data="onMemberWeightDataChange"
                            />
                        </van-col>
                        <van-col class="b-outer-margin" span="12">
                            <checkbox-card
                                :label="locale['signup-member-config-type-9']"
                                :checked="matchGroup.isMemberSuitSizeChecked"
                                @change-data="onMemberSuitSizeDataChange"
                            />
                        </van-col>
                        <van-col class="b-outer-margin" span="12">
                            <checkbox-card
                                :label="locale['signup-member-config-type-10']"
                                :checked="matchGroup.isMemberShoeSizeChecked"
                                @change-data="onMemberShoeSizeDataChange"
                            />
                        </van-col>
                        <van-col class="b-outer-margin" span="12">
                            <checkbox-card
                                :label="locale['signup-member-config-type-17']"
                                :checked="matchGroup.isMemberSuitNameChecked"
                                @change-data="onMemberSuitNameDataChange"
                            />
                        </van-col>
                        <van-col class="b-outer-margin" span="12">
                        </van-col>
                    </van-row>
                </van-tab>
                <van-tab class="t-outer-margin" :title="locale['other-data-tab-type-2']">
                    <van-row class="u-inner-padding" gutter="10">
                        <van-col class="b-outer-margin" span="12">
                            <checkbox-card
                                :label="locale['signup-member-config-type-11']"
                                :checked="matchGroup.isMemberParentNameChecked"
                                @change-data="onMemberParentNameDataChange"
                            />
                        </van-col>
                        <van-col class="b-outer-margin" span="12">
                            <checkbox-card
                                :label="locale['signup-member-config-type-12']"
                                :checked="matchGroup.isMemberParentContactPhoneChecked"
                                @change-data="onMemberParentContactPhoneDataChange"
                            />
                        </van-col>
                        <van-col class="b-outer-margin" span="12">
                            <checkbox-card
                                :label="locale['signup-member-config-type-13']"
                                :checked="matchGroup.isMemberSchoolChecked"
                                @change-data="onMemberSchoolDataChange"
                            />
                        </van-col>
                        <van-col class="b-outer-margin" span="12">
                        </van-col>
                    </van-row>
                </van-tab>
                <van-tab class="t-outer-margin" :title="locale['other-data-tab-type-3']">
                    <van-row class="u-inner-padding" gutter="10">
                        <van-col class="b-outer-margin" span="12">
                            <checkbox-card
                                :label="locale['signup-member-config-type-14']"
                                :checked="matchGroup.isMemberInsuranceChecked"
                                @change-data="onMemberInsuranceDataChange"
                            />
                        </van-col>
                        <van-col class="b-outer-margin" span="12">
                            <checkbox-card
                                :label="locale['signup-member-config-type-15']"
                                :checked="matchGroup.isMemberPositionChecked"
                                @change-data="onMemberPositionDataChange"
                            />
                        </van-col>
                        <van-col class="b-outer-margin" span="12">
                            <checkbox-card
                                :label="locale['signup-member-config-type-16']"
                                :checked="matchGroup.isMemberQualificationChecked"
                                @change-data="onMemberQualificationDataChange"
                            />
                        </van-col>
                        <van-col class="b-outer-margin" span="12">
                            <checkbox-card
                                :label="locale['signup-member-config-type-17']"
                                :checked="matchGroup.isMemberSuitNameChecked"
                                @change-data="onMemberSuitNameDataChange"
                            />
                        </van-col>
                        <van-col class="b-outer-margin" span="12">
                            <checkbox-card
                                :label="locale['signup-member-config-type-18']"
                                :checked="matchGroup.isMemberDutyChecked"
                                @change-data="onMemberDutyDataChange"
                            />
                        </van-col>
                        <van-col class="b-outer-margin" span="12">
                        </van-col>
                    </van-row>
                </van-tab>
                <van-tab class="t-outer-margin" :title="locale['other-data-tab-type-4']">
                    <van-row class="u-inner-padding" gutter="10">
                        <van-col class="b-outer-margin" span="12">
                            <checkbox-card
                                :label="locale['signup-member-config-type-19']"
                                :checked="matchGroup.isMemberCityChecked"
                                @change-data="onMemberCityDataChange"
                            />
                        </van-col>
                        <van-col class="b-outer-margin" span="12">
                            <checkbox-card
                                :label="locale['signup-member-config-type-20']"
                                :checked="matchGroup.isMemberNationChecked"
                                @change-data="onMemberNationDataChange"
                            />
                        </van-col>
                        <van-col class="b-outer-margin" span="12">
                            <checkbox-card
                                :label="locale['signup-member-config-type-21']"
                                :checked="matchGroup.isMemberCountryChecked"
                                @change-data="onMemberCountryDataChange"
                            />
                        </van-col>
                        <van-col class="b-outer-margin" span="12">
                            <checkbox-card
                                :label="locale['signup-member-config-type-22']"
                                :checked="matchGroup.isMemberWorkUnitChecked"
                                @change-data="onMemberWorkUnitDataChange"
                            />
                        </van-col>
                        <van-col class="b-outer-margin" span="12">
                            <checkbox-card
                                :label="locale['signup-member-config-type-23']"
                                :checked="matchGroup.isMemberProfessionChecked"
                                @change-data="onMemberProfessionDataChange"
                            />
                        </van-col>
                        <van-col class="b-outer-margin" span="12">
                            <checkbox-card
                                :label="locale['signup-member-config-type-24']"
                                :checked="matchGroup.isMemberTeamChecked"
                                @change-data="onMemberTeamDataChange"
                            />
                        </van-col>
                        <van-col class="b-outer-margin" span="12">
                            <checkbox-card
                                :label="locale['signup-member-config-type-25']"
                                :checked="matchGroup.isMemberRegistrationCodeChecked"
                                @change-data="onMemberRegistrationCodeDataChange"
                            />
                        </van-col>
                        <van-col class="b-outer-margin" span="12">
                            <checkbox-card
                                :label="locale['signup-member-config-type-26']"
                                :checked="matchGroup.isMemberProfessionalPlayerChecked"
                                @change-data="onMemberProfessionalPlayerDataChange"
                            />
                        </van-col>
                        <van-col class="b-outer-margin" span="12">
                            <checkbox-card
                                :label="locale['signup-member-config-type-27']"
                                :checked="matchGroup.isMemberEmergencyContactChecked"
                                @change-data="onMemberEmergencyContactDataChange"
                            />
                        </van-col>
                        <van-col class="b-outer-margin" span="12">
                        </van-col>
                    </van-row>
                </van-tab>
                <van-tab class="t-outer-margin" :title="locale['other-data-tab-type-5']">
                    <van-row class="u-inner-padding" gutter="10">
                        <van-col class="b-outer-margin" span="12">
                            <checkbox-card
                                :label="locale['signup-member-config-type-28']"
                                :checked="matchGroup.isMemberRemarkChecked"
                                @change-data="onMemberRemarkDataChange"
                            />
                        </van-col>
                        <van-col class="b-outer-margin" span="12">
                        </van-col>
                    </van-row>
                </van-tab>
            </van-tabs>
        </div>
    </div>
</template>